<template>
    <div class="container">
    <el-col :span="24">
      <div class="search">
        <el-col :span="10">
        <el-input v-model="formData.keyword" placeholder="请输入招标标题或工厂名"></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="searchBidFactory()">搜索</el-button>
      </el-col>
      </div>
      
    </el-col>
    <el-table :data="tableData" style="width: 100%" height="690" border>
      <el-table-column fixed prop="bid_title" label="招标标题" width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="factory_name" label="工厂名" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="offer" label="报价金额" width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="time" label="创建时间" width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="win" label="中标情况" width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="pay" label="已付金额" width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="pay_img" label="付款记录" width="100" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="formData.page"
      :page-sizes="[20,60,100,140]"
      :page-size="formData.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "Offer",
  props: ['bidId'],
  data() {
    return {
      id: 0,
      formData: {
        keyword: "",
        startDate: "",
        endDate: "",
        page: 1,
        limit: 20
      },
      count: 0,
      tableData: [],
      
    };
  },
  methods: {
      searchBidFactory(){
          this.$http
        .post("/v2/validate/SearchBidFactory", { 
            id : this.id,
            formData : this.formData 
        })
        .then(res => {
          console.log(res.data);
          this.tableData = res.data;
          this.count = res.count;
        })
        .catch(error => {
          console.log(error);
        });
      }
  },
  created() {
    
  },
  mounted(){
    if (!!this.$route.query.id){
      this.id = this.$route.query.id;
    }
    
    if (!!this.bidId){
      this.id = this.bidId
    }
    console.log(this.bidId)
    this.searchBidFactory()
  }
};
</script>

<style scoped>
.pagination{text-align: center;margin-bottom: 25px;}
.search{text-align: center }
.search .el-col {margin-bottom: 15px}
</style>